import {isBoardPayloadSelectOption, type BoardPayloadItem} from '../board-payload'
import {isCustomFieldIdentifier} from '../visible-card-fields'

/** Semantic values keyed by registry field identifier, without local placeholder IDs or display metadata. */
export function projectIssueCardForVerification(item: BoardPayloadItem): unknown {
  const fields: Record<string, unknown> = {...item.fields}
  if (item.fields.label) fields.label = {value: item.fields.label.value.map(label => label.name).sort()}
  if (item.fields.assignee) fields.assignee = {value: item.fields.assignee.value.map(actor => actor.login).sort()}
  if (item.fields.milestone) fields.milestone = {value: item.fields.milestone.value?.url ?? null}
  if (item.type === 'issue') {
    if (item.fields['parent-issue']) fields['parent-issue'] = {value: item.fields['parent-issue'].value?.url ?? null}
    if (item.fields.issue_type) fields.issue_type = {value: item.fields.issue_type.value?.name ?? null}
    for (const [key, slot] of Object.entries(item.fields)) {
      if (isCustomFieldIdentifier(key) && slot) fields[key] = {value: projectCustomValue(slot.value)}
    }
  }
  return {
    ...fields,
    title: item.title,
    state: item.state,
    ...(item.type === 'issue' ? {stateReason: item.stateReason, status: item.status} : {}),
  }
}

function projectCustomValue(value: unknown): unknown {
  if (isBoardPayloadSelectOption(value)) return value.name
  if (Array.isArray(value) && value.every(isBoardPayloadSelectOption)) {
    return value.map(option => option.name).sort()
  }
  return value
}
